export class ImportedRetailersFileMetrics {
    retailersCount: number;
    marketsCount: number;
}